<template>
  <layout-editor-page
    :title="formTitle"
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="hasCreateNew"
    :isCancel="!hasCreateNew"
    @command="setCommand"
  >
    <edit-form
      :disabled="disabled"
      :data="data"
      :model="formModel"
      @updateModelItem="handlerUpdateModelItem"
      @updateCompany="updateCompanyName"
      @change="handleFormData"
      ref="Form"/>
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        :isCreate="!hasCreateNew && !disabled"
        :isSave="hasCreateNew && !disabled"
        :isDelete="hasCreateNew && !disabled"
        @command="setCommand"/>
    </template>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'ModalNewLabel',
  mixins: [FormWrapperAutoSave, FormWrapper],
  components: {
    'edit-form': () => import(/* webpackChunkName: 'NonConformityAnalyzes' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object }
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'NonConformityAnalyzes/Patch/${data.id}',
      currentCompanyName: null
    }
  },
  computed: {
    formTitle () {
      let title = []
      if (this.formData.findingDate) {
        let date = this.$moment(this.formData.findingDate).format('DD/MM/YYYY')
        title.push(date)
      }
      if (typeof this.formData.companyID === 'number' && this.currentCompanyName) {
        title.push(this.currentCompanyName)
      }
      return title.join(' - ') || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        companyID: null,
        findingDate: null,
        writtenbyEmployeeID: null,

        nonConformityNatureID: null,
        nonConformityNatureID2: null,
        nonConformityOriginID: null,

        nonConformityDysfunctionID: null,
        nonConformityDysfunctionDetailID: null,

        analyzeDescription: '',

        nonConformityActionID: null,
        originDysfunctionCompanyID: null,
        verificationDate: null,

        propositionDaction: '',

        actionResults: '',
        actionResultsDate: null,

        employeeInchargeID: null,
        employeeSignatureRQID: null,
        done: false,
        immediateProvisions: false,
        graveOrNonGrave: false
      }
    },
    updateCompanyName (source) {
      this.currentCompanyName = source && source.name
    }
  }
}
</script>

<style lang="stylus">
</style>
